import { ICoordinates } from '@/utility/commonDataTypes';
import { TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';

export enum EAutoSearchFilters {
  ADDRESS = 'address',
  MAPBOX_ID = 'mapbox_id',
  NEAR = 'near',
  NEAR_RENTAL = 'near_rental',
  DATE_FROM = 'date[from]',
  DATE_TO = 'date[to]',
  FLEXIBLE_DAYS = 'flexible_days',
  RAW_JSON = 'raw_json',
  BOUNDS_NE = 'bounds[ne]',
  BOUNDS_SW = 'bounds[sw]',
  PAGE_LIMIT = 'page[limit]',
  PAGE_OFFSET = 'page[offset]',
  OMIT_AGGREGATION = 'omit_aggregation',
  INCLUDE_TOTAL_PRICE_AGGREGATION = 'include_total_price_aggregation',
  AVAILABILITY_WINDOW = 'availability_window',
  RENTAL_CATEGORY = 'filter[rental_category]',
  INSTANT_BOOK = 'instant_book',
  PRICE_MIN = 'price[min]',
  PRICE_MAX = 'price[max]',
  FILTER_TYPE = 'filter[type]',
  FILTER_TAGS_SLUG = 'filter[tags-slug]',
  FILTER_FEATURE = 'filter[feature]',
  FILTER_KEYWORDS = 'filter[keywords]',
  YEAR_GTE = 'year[gte]',
  YEAR_LTE = 'year[lte]',
  SCORE = 'score',
  SEATBELTS = 'seatbelts',
  SORT = 'sort',
}

export type TAutoRentalMarker = ICoordinates & {
  tiles: TAutoRentalTile[];
};
